import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./FloatingMenu.css";

const QuranIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M12 5.1c-1.2-1.02-2.66-1.53-4.4-1.53H5.9A2.9 2.9 0 0 0 3 6.47v10.34c0 1.6 1.3 2.9 2.9 2.9h1.7c1.87 0 3.35.6 4.4 1.79m0-16.4c1.2-1.02 2.66-1.53 4.4-1.53h1.7A2.9 2.9 0 0 1 21 6.47v10.34c0 1.6-1.3 2.9-2.9 2.9h-1.7c-1.87 0-3.35.6-4.4 1.79"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 5.1v16.4" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M6.2 8.1h3.9M6.2 10.4h3.9M6.2 12.7h2.8" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.95" />
    <path d="M13.9 8.1h3.9M13.9 10.4h3.9M13.9 12.7h2.8" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.95" />
    <circle cx="12" cy="14.9" r="0.95" fill="currentColor" opacity="0.88" />
  </svg>
);

const FloatingMenu = () => {
  const location = useLocation();
  const menuItems = [
    {
      path: "/",
      label: "Événements",
      icon: "bi-calendar-event",
      color: "#28a745"
    },
    {
      path: "/articles",
      label: "Articles",
      icon: "bi-journal-text",
      color: "#007bff"
    },
    {
      path: "/news",
      label: "News",
      icon: "bi-newspaper",
      color: "#fd7e14"
    },
    {
      path: "/quiz",
      label: "Quiz",
      icon: "bi-question-circle",
      color: "#f1c40f"
    },
    {
      path: "/dhikr",
      label: "Dhikr",
      icon: "bi-moon-stars",
      color: "#2fac66"
    },
    {
      path: "/quran",
      label: "Quran",
      svgIcon: QuranIcon,
      color: "#16a085"
    },
    {
      path: "/profile",
      label: "Profil",
      icon: "bi-person-circle",
      color: "#dc3545"
    }
  ];

  const isActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <div className="floating-menu">
      <div className="floating-menu-container">
        {menuItems.map((item, index) => (
          <Link
            key={index}
            to={`${process.env.PUBLIC_URL}${item.path}`}
            className={`floating-menu-item ${isActive(item.path) ? 'active' : ''}`}
            style={{
              '--item-color': item.color
            }}
          >
            <div className="floating-menu-icon">
              {item.svgIcon ? <item.svgIcon /> : <i className={`bi ${item.icon}`}></i>}
            </div>
            <span className="floating-menu-label">{item.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FloatingMenu;
